//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/ErrorList.js";
import "../no/PartLoadStatus.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AllowTemporaryPartsToReplace",1,0],[0,"ComponentLayer",1,0],[0,"ComponentLayerOptionType",1,0],[0,"ComponentName",1,0],[0,"ComponentNameType",1,0],[1,"ComponentsToReplace",0,"SelectDisplayableObjectList",0],[0,"MaintainRelationships",1,0],[0,"ReplaceAllOccurrences",1,0],[0,"ReplacementPart",1,0]],[[["referenceSetName"],"GetComponentReferenceSetType",{R_:{componentReferenceSet:''}},0,0],[["componentReferenceSet","referenceSetName"],"SetComponentReferenceSetType",{},2,0],[[],"RegisterReplacePartLoadStatus",{R_:{replaceLoadStatus:"PartLoadStatus"}},0,0],[[],"GetErrorList",{R_:{errorList:"ErrorList"}},0,0]],[]];
SPLM.Assemblies.ReplaceComponentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.ReplaceComponentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.ReplaceComponentBuilder.ComponentReferenceSet = Object.freeze({
    "Maintain" : "Maintain", "EntirePart" : "EntirePart", "Empty" : "Empty", "Others" : "Others"});

SPLM.Assemblies.ReplaceComponentBuilder.ComponentLayerOption = Object.freeze({
    "Maintain" : "Maintain", "Original" : "Original", "Work" : "Work", "AsSpecified" : "AsSpecified"});

SPLM.Assemblies.ReplaceComponentBuilder.ComponentNameOption = Object.freeze({
    "Maintain" : "Maintain", "Original" : "Original", "AsSpecified" : "AsSpecified"});

export default SPLM;